import React from 'react';
import { Link } from 'gatsby';
import ThemeToggle from './ThemeToggle';
let site = require('./../../siteConfig');

const Layout = props => {
  const { title, children } = props;
  const [toggleNav, setToggleNav] = React.useState(false);
  const closeNav = () => setToggleNav(false);
  return (
    <div className={`site-wrapper ${toggleNav ? `site-head-open` : ``}`}>
      <header className="site-head">
        <div className="site-head-container">
          <button
            type="button"
            className="nav-burger"
            aria-label="Menu"
            aria-controls="navigation"
            aria-expanded={toggleNav}
            onClick={() => setToggleNav(!toggleNav)}
          >
            <div className="hamburger hamburger--collapse">
              <div className="hamburger-box">
                <div className="hamburger-inner" />
              </div>
            </div>
          </button>
          <nav id="navigation" className="site-head-left">
            <ul className="nav">
              <li className="nav-about">
                <Link to={`/about`} onClick={closeNav}>
                  About
                </Link>
              </li>
              <li className="nav-blog">
                <Link to={`/blog`} onClick={closeNav}>
                  Blog
                </Link>
              </li>
            </ul>
          </nav>
          <div className="site-head-center">
            <Link className="site-head-logo" to={`/`} onClick={closeNav}>
              {title}
            </Link>
          </div>
          <div className="site-head-right">
            <div className="social-links">
              <a
                href={site.github}
                title="GitHub"
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub
              </a>
              <a
                href={site.linkedin}
                title="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
              {site.resume && (
                <a
                  href={site.resume}
                  title="CV"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CV
                </a>
              )}
            </div>
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main">
        <div id="swup" className="transition-fade">
          {children}
        </div>
      </main>
      <footer className="site-foot">
        <div className="site-foot-inner">
          <span className="site-foot-copy">
            &copy; {new Date().getFullYear()} <Link to={`/`}>{title}</Link> &middot;
            Built with{' '}
            <a href="https://gatsbyjs.org" target="_blank" rel="noopener noreferrer">
              Gatsby
            </a>
          </span>
          <ThemeToggle />
        </div>
      </footer>
    </div>
  );
};

export default Layout;
